"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAccentClassNamesWithSuffix = getAccentClassNamesWithSuffix;
exports.accents = exports.WARNING = exports.SUCCESS = exports.PRIMARY = exports.DANGER = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var DANGER = 'danger';
exports.DANGER = DANGER;
var PRIMARY = 'primary';
exports.PRIMARY = PRIMARY;
var SUCCESS = 'success';
exports.SUCCESS = SUCCESS;
var WARNING = 'warning';
exports.WARNING = WARNING;
var accents = [DANGER, PRIMARY, SUCCESS, WARNING];
exports.accents = accents;

function getAccentClassNamesWithSuffix(className, accent) {
  var _ref;

  return _ref = {}, (0, _defineProperty2.default)(_ref, "".concat(className, "--").concat(DANGER), accent === DANGER), (0, _defineProperty2.default)(_ref, "".concat(className, "--").concat(PRIMARY), accent === PRIMARY), (0, _defineProperty2.default)(_ref, "".concat(className, "--").concat(SUCCESS), accent === SUCCESS), (0, _defineProperty2.default)(_ref, "".concat(className, "--").concat(WARNING), accent === WARNING), _ref;
}